
import Boxcard from "./Boxcard"; 
import FeeDetailsList from "./FeeDetailsList"; 
import TopperList from "./TopperList"; 
import "./box.css";
const Dashboard = () => {
  return (
    <div
      className="Dashboard flex flex-col gap-[10px] h-full overflow-y-scroll p-[10px] [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500"
    >
      <Boxcard />
      

      <div className="Dashbaord-section-last">
        <ul>
          <li>
            <FeeDetailsList />
          </li>
          <li>
            <TopperList />
          </li>
        </ul>
      </div>

      {/* <Sub/> */}
    </div>
  );
};

export default Dashboard;
